import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Checkbox, message } from 'antd';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const MESES = [
    { value: 0, label: 'ENERO' },
    { value: 1, label: 'FEBRERO' },
    { value: 2, label: 'MARZO' },
    { value: 3, label: 'ABRIL' },
    { value: 4, label: 'MAYO' },
    { value: 5, label: 'JUNIO' },
    { value: 6, label: 'JULIO' },
    { value: 7, label: 'AGOSTO' },
    { value: 8, label: 'SEPTIEMBRE' },
    { value: 9, label: 'OCTUBRE' },
    { value: 10, label: 'NOVIEMBRE' },
    { value: 11, label: 'DICIEMBRE' },
];

const NuevaQuincenaModal = ({ open, onClose, onCreated }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [copiarAnterior, setCopiarAnterior] = useState(true);

    const token = localStorage.getItem('token');
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    // Defaults: current month/year and auto-detect 1a or 2a quincena
    const hoy = moment();
    const defaultMes = hoy.month();
    const defaultAño = hoy.year();
    const defaultQuincena = hoy.date() <= 15 ? '1A' : '2A';

    // Generate list of years (free range)
    const años = [];
    for (let y = defaultAño + 1; y >= 2020; y--) {
        años.push({ value: y, label: `${y}` });
    }

    // Generate quincena name from selections
    const generarNombre = (mes, año, quincena) => {
        const mesLabel = MESES.find(m => m.value === mes)?.label || '';
        return `${quincena} QUINCENA DE ${mesLabel} ${año}`;
    };

    // Generate start/end dates from selections
    const generarFechas = (mes, año, quincena) => {
        if (quincena === '1A') {
            return {
                fecha_inicio: moment([año, mes, 1]).format('YYYY-MM-DD'),
                fecha_fin: moment([año, mes, 15]).format('YYYY-MM-DD'),
            };
        } else {
            const ultimoDia = moment([año, mes]).endOf('month').date();
            return {
                fecha_inicio: moment([año, mes, 16]).format('YYYY-MM-DD'),
                fecha_fin: moment([año, mes, ultimoDia]).format('YYYY-MM-DD'),
            };
        }
    };

    // Update the auto-generated name whenever selectors change
    const handleValuesChange = (changedValues, allValues) => {
        const { mes, año, quincena } = allValues;
        if (mes !== undefined && año !== undefined && quincena !== undefined) {
            form.setFieldsValue({ nombre: generarNombre(mes, año, quincena) });
        }
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const { fecha_inicio, fecha_fin } = generarFechas(values.mes, values.año, values.quincena);

            await axios.post('/api/v1/quincenas', {
                nombre: values.nombre,
                fecha_inicio,
                fecha_fin,
                copiar_anterior: copiarAnterior
            }, config);

            message.success('Quincena creada exitosamente');
            form.resetFields();
            onCreated?.();
        } catch (error) {
            console.error('Error al crear quincena:', error);
            message.error('Error al crear la quincena');
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title="Nueva Quincena"
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={loading}
            okText="Crear Quincena"
            cancelText="Cancelar"
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    mes: defaultMes,
                    año: defaultAño,
                    quincena: defaultQuincena,
                    nombre: generarNombre(defaultMes, defaultAño, defaultQuincena),
                }}
                onValuesChange={handleValuesChange}
            >
                <div style={{ display: 'flex', gap: 12 }}>
                    <Form.Item
                        name="mes"
                        label="Mes"
                        rules={[{ required: true, message: 'Selecciona un mes' }]}
                        style={{ flex: 2 }}
                    >
                        <Select options={MESES} placeholder="Mes" />
                    </Form.Item>

                    <Form.Item
                        name="año"
                        label="Año"
                        rules={[{ required: true, message: 'Selecciona un año' }]}
                        style={{ flex: 1 }}
                    >
                        <Select options={años} placeholder="Año" />
                    </Form.Item>

                    <Form.Item
                        name="quincena"
                        label="Quincena"
                        rules={[{ required: true, message: 'Selecciona quincena' }]}
                        style={{ flex: 1 }}
                    >
                        <Select
                            options={[
                                { value: '1A', label: '1a Quincena' },
                                { value: '2A', label: '2a Quincena' },
                            ]}
                            placeholder="Quincena"
                        />
                    </Form.Item>
                </div>

                <Form.Item
                    name="nombre"
                    label="Nombre de la Quincena"
                    rules={[{ required: true, message: 'El nombre es requerido' }]}
                >
                    <Input placeholder="Ej: 2A QUINCENA DE FEBRERO 2026" />
                </Form.Item>

                <Form.Item>
                    <Checkbox
                        checked={copiarAnterior}
                        onChange={(e) => setCopiarAnterior(e.target.checked)}
                    >
                        Copiar pagos de la quincena anterior
                    </Checkbox>
                    <div style={{ color: '#888', fontSize: 12, marginTop: 4 }}>
                        Los montos de pago quincenal se copiarán de la última quincena cerrada
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default NuevaQuincenaModal;
